import { PipelineDestinationSubscriptionPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { subscriptionRouteParams } from '@/services/router/pipeline-route-params';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId',
)({
  params: subscriptionRouteParams,
  component: PipelineDestinationSubscriptionPage,
});
